import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import PageLayout from './PageLayout';
import { markPending } from '../utils/pendingReports';

const MESSAGES = [
  '正在分析你的作答数据...',
  '计算各维度得分...',
  '生成个性化评估报告...',
  '报告即将完成...',
];

/**
 * 报告生成等待屏 — 测评提交后到报告就绪之间显示。
 *
 * 历史：之前有两层等待页（AssessmentLoadingPage + ReportPageV2 内部 loading），
 * 串联跳转时用户会看到两个不同样式的等待界面。2026-05-09 合并：
 * 测评完成后直接跳 /report/{id}，由 ReportPageV2 内部 loading/polling 期间渲染本组件。
 *
 * 2026-05-25：增加"返回首页"出口 + 通过 markPending('rough', id) 让顶导后台
 * polling 在 done 时弹气泡。
 */
export default function ReportLoadingScreen({ assessmentId }) {
  const [msgIdx, setMsgIdx] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setMsgIdx(i => (i + 1) % MESSAGES.length), 2500);
    return () => clearInterval(t);
  }, []);

  // V2 老路径上的等待页，统一走 markPending：顶导后台 polling 检测 done 后才弹气泡。
  useEffect(() => { markPending('rough', assessmentId); }, [assessmentId]);

  return (
    <PageLayout showNav={false}>
      <div style={{
        display: 'flex', flexDirection: 'column', alignItems: 'center',
        justifyContent: 'center', minHeight: '100vh', gap: 32,
      }}>
        <div style={{
          width: 72, height: 72, borderRadius: '50%',
          border: '4px solid var(--color-primary-light)',
          borderTopColor: 'var(--color-primary)',
          animation: 'spin 1s linear infinite',
        }} />
        <style>{`@keyframes spin { to { transform: rotate(360deg) } }`}</style>
        <div style={{ textAlign: 'center' }}>
          <h2 style={{ fontSize: 20, fontWeight: 700, marginBottom: 8 }}>正在生成你的 AIQ 报告</h2>
          <p style={{ color: 'var(--color-text-secondary)', fontSize: 15 }}>{MESSAGES[msgIdx]}</p>
        </div>
        <p style={{ fontSize: 13, color: 'var(--color-text-muted)' }}>通常需要 5-30 秒，请稍候...</p>
        <Link to="/" style={{
          border: '1.5px solid #d6e0f5',
          borderRadius: 8,
          padding: '8px 20px',
          color: '#26314f',
          fontSize: 13,
          fontWeight: 500,
          textDecoration: 'none',
          background: '#fff',
        }}>返回首页</Link>
      </div>
    </PageLayout>
  );
}
